import { useMemo } from "react";

export const useIframe = () => {
  return useMemo(() => {
    return {
      element: document.createElement("iframe"),
      mounting: false,
      init(url = "https://kei.fi/connect") {
        this.element.src = url;
        this.element.className = "kei-connect-frame hidden";
      },
      show() {
        this.element.classList.remove("hidden");
      },
      hide() {
        this.element.classList.add("hidden");
      },
      get mounted() {
        return document.contains(this.element);
      },
      mount() {
        if (this.mounted || this.mounting) {
          return;
        }

        // This conditional is not Penpal-specific. It's merely
        // an example of how you can add an iframe to the document.
        if (
          document.readyState === "complete" ||
          document.readyState === "interactive"
        ) {
          document.body.appendChild(this.element);
        } else {
          this.mounting = true;
          document.addEventListener("DOMContentLoaded", () => {
            if (this.mounting) {
              document.body.appendChild(this.element);
              this.mounting = false;
            }
          });
        }
      },
      unmount() {
        if (this.mounted) {
          this.element.remove();
        }
        this.mounting = false;
      },
    };
  }, []);
};
